import React, {FC, ReactNode} from 'react';
import {useLocation} from "react-router-dom";
import {IS_SEPARATED, LOGIN_PATH} from "@constants/config";
import AuthSeparate from "@containers/auth/AuthSeparate";
import AuthWithTrek from "@containers/auth/AuthWithTrek";
import LoginPage from "@pages/login/LoginPage";

interface IProps {
    children: ReactNode,
}

const Auth: FC<IProps> = ({children}) => {

    const {pathname} = useLocation()

    if (pathname.replace(/\/+$/, '') === LOGIN_PATH) {
        return <LoginPage/>
    }

    if (IS_SEPARATED) {
        return (
            <AuthSeparate>
                {children}
            </AuthSeparate>
        )
    }
    return (
        <AuthWithTrek>
            {children}
        </AuthWithTrek>
    );
};

export default Auth;
